import type { APIRuntimeBuilder } from '@cian/mf-registry/browser';

import { getOrEnsureHeaderUIAPIController } from '../headerUIAPIController/bridge';
import { HEADER_UI_API_PATHS } from '../headerUIAPIController/constants';

import type { IHeaderUIAPIScope, THeaderUIAPIArgumentsMap } from '../headerUIAPIController/types';

export function buildAPIRuntime(scope: IHeaderUIAPIScope): APIRuntimeBuilder {
  return [
    {
      path: HEADER_UI_API_PATHS.openAuthModalV2,
      handler: async (parameters?: THeaderUIAPIArgumentsMap[typeof HEADER_UI_API_PATHS.openAuthModalV2][0]) =>
        (await getOrEnsureHeaderUIAPIController(scope)).methods[HEADER_UI_API_PATHS.openAuthModalV2](parameters),
    },
    {
      path: HEADER_UI_API_PATHS.setRegionIdV2,
      handler: async (parameters: THeaderUIAPIArgumentsMap[typeof HEADER_UI_API_PATHS.setRegionIdV2][0]) =>
        (await getOrEnsureHeaderUIAPIController(scope)).methods[HEADER_UI_API_PATHS.setRegionIdV2](parameters),
    },
    {
      path: HEADER_UI_API_PATHS.updateHeaderV2,
      handler: async () =>
        (await getOrEnsureHeaderUIAPIController(scope)).methods[HEADER_UI_API_PATHS.updateHeaderV2](),
    },
    {
      path: HEADER_UI_API_PATHS.openAuthModalV3,
      handler: async (parameters?: THeaderUIAPIArgumentsMap[typeof HEADER_UI_API_PATHS.openAuthModalV3][0]) =>
        (await getOrEnsureHeaderUIAPIController(scope)).methods[HEADER_UI_API_PATHS.openAuthModalV3](parameters),
    },
    {
      path: HEADER_UI_API_PATHS.setRegionIdV3,
      handler: async (parameters: THeaderUIAPIArgumentsMap[typeof HEADER_UI_API_PATHS.setRegionIdV3][0]) =>
        (await getOrEnsureHeaderUIAPIController(scope)).methods[HEADER_UI_API_PATHS.setRegionIdV3](parameters),
    },
    {
      path: HEADER_UI_API_PATHS.updateHeaderV3,
      handler: async () =>
        (await getOrEnsureHeaderUIAPIController(scope)).methods[HEADER_UI_API_PATHS.updateHeaderV3](),
    },
  ];
}
